const closeBtn = document.getElementById('js-emi-ctaClose');
const cta = document.getElementById('js-emi-cta');

closeBtn?.addEventListener('click', () => {
  cta.style.transition = 'opacity 0.4s';
  cta.style.opacity = '0';
  cta.addEventListener('transitionend', () => {
    cta.style.display = 'none';
  }, { once: true });
});
